import { TableEmptyState } from '@practium/ui';
import type { Fertilizer } from '../../../types';
import { getFertilizerCategoryLabel } from '../../../constants/fertilizer.constants';
import styles from '../DefensivesTable/DefensivesTable.module.css';

const NATURE_LABELS: Record<Fertilizer['nature'], string> = {
	solid: 'Sólido',
	liquid: 'Líquido',
};

interface FertilizersTableProps {
	fertilizers: Fertilizer[];
	resolveUserName: (userId: string | null) => string;
	onRowClick?: (id: string) => void;
}

export const FertilizersTable = ({
	fertilizers,
	resolveUserName,
	onRowClick,
}: FertilizersTableProps) => {
	if (fertilizers.length === 0) {
		return (
			<TableEmptyState
				title="Nenhum fertilizante encontrado"
				subtitle="Adicione um fertilizante para começar"
			/>
		);
	}

	return (
		<div className={styles.tableWrapper}>
			<table className={styles.table}>
				<thead className={styles.thead}>
					<tr>
						<th>Nome do Produto</th>
						<th>Fabricante</th>
						<th>Categoria</th>
						<th>Natureza</th>
						<th>Origem</th>
					</tr>
				</thead>
				<tbody className={styles.tbody}>
					{fertilizers.map((item) => {
						const isAdmin = item.owner === 'admin';
						const originLabel = isAdmin ? 'Admin' : resolveUserName(item.owner);
						return (
							<tr
								key={item._id}
								onClick={() => onRowClick?.(item._id)}
								className={onRowClick ? styles.clickableRow : undefined}
							>
								<td>
									<span className={styles.cellPrimary}>{item.name}</span>
								</td>
								<td>
									<span className={styles.cellSecondary}>
										{item.manufacturer?.businessName ?? item.manufacturer?.tradingName ?? '—'}
									</span>
								</td>
								<td>
									<span className={styles.cellSecondary}>
										{getFertilizerCategoryLabel(item.category)}
									</span>
								</td>
								<td>
									<span className={styles.cellSecondary}>{NATURE_LABELS[item.nature]}</span>
								</td>
								<td>
									<span
										className={`${styles.originBadge} ${
											isAdmin ? styles.originBadgeAdmin : styles.originBadgeClient
										}`}
									>
										{originLabel}
									</span>
								</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		</div>
	);
};
